import { useState, useEffect } from 'react';
import ruumLogoDark from '../assets/ruum-logo-dark.svg';
import ruumLogoPNG from '../assets/ruum-logo.png';
import fotoMagda from '../assets/zdjęciemagda.JPG';
import fotoAga from '../assets/20211022_152943-02.jpeg';
import fotoEdyta from '../assets/c7664d94-4f1d-4b91-8349-d295830f21c2.jpg';
import "./Home.scss";
import archiMain from '../assets/archi1.jpg'; 
import ofertaPDF from '../assets/ruum_flow_and co_bio.pdf';
import Papa from 'papaparse';

const formatPolishText = (text) => {
  if (!text) return "";
  return text.replace(/ ([iwzoau]) /gi, " $1&nbsp;");
};

function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cms, setCms] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sheetUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRj0wnpqoG5rNY1eE2JHNdVtjLEHEMwTw4oQXLWiv9SLINEKFJ361jWkII2INnPkL-25aa3ZpF3n6aS/pub?output=csv";

    Papa.parse(sheetUrl, {
      download: true,
      header: false,
      complete: (results) => {
        const mapped = {};
        results.data.forEach(row => {
          if (row[0]) mapped[row[0].trim()] = row[1];
        });
        setCms(mapped);
        setLoading(false);
      }
    });
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  if (loading) return null;

  return (
    <main className="home">
      <nav className={`nav ${mobileMenuOpen ? 'nav--open' : ''}`}>
        <button className="nav__logo" onClick={scrollToTop}>
          <span className="nav__logoRuum">ruum.</span>
          <span className="nav__logoFlow">flow </span>
          <span className="nav__logoCo">&nbsp;&amp;&nbsp;co.</span>
        </button>
        <ul className={`nav__menu ${mobileMenuOpen ? 'nav__menu--open' : ''}`}>
          <li><button onClick={() => scrollToSection('o-nas')} className="nav__link">O nas</button></li>
          <li><button onClick={() => scrollToSection('filozofia')} className="nav__link">Filozofia</button></li>
          <li>
            <a 
              href={ofertaPDF} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="nav__link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Oferta
            </a>
          </li>

          <li><button onClick={() => scrollToSection('uslugi')} className="nav__link">Usługi</button></li>
          <li><button onClick={() => scrollToSection('dlaczego')} className="nav__link">Dlaczego ruum</button></li>
          <li><button onClick={() => scrollToSection('zespol')} className="nav__link">Zespół</button></li>
          <li><button onClick={() => scrollToSection('kontakt')} className="nav__link nav__link--cta">Kontakt</button></li>
        </ul>
        <button 
          className={`nav__hamburger ${mobileMenuOpen ? 'nav__hamburger--open' : ''}`} 
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div className="colorBar">
        <span className="colorBar__swatch colorBar__swatch--cream"></span>
        <span className="colorBar__swatch colorBar__swatch--yellow"></span>
        <span className="colorBar__swatch colorBar__swatch--coral"></span>
        <span className="colorBar__swatch colorBar__swatch--sage"></span>
        <span className="colorBar__swatch colorBar__swatch--mint"></span>
        <span className="colorBar__swatch colorBar__swatch--teal"></span>
      </div>

      <section className="heroSection">
        <img src={ruumLogoPNG} alt="ruum. flow & co." className="heroSection__logo" />
      </section>

      <section className="bentoGrid">
        <div className="bentoGrid__imageBlock">
          <img
            src={archiMain}
            alt="Struktura i Architektura"
            className="bentoGrid__image"
          />
        </div>

        <div className="bentoGrid__rightColumn">
          <div className="bentoGrid__brandBlock">
            <img src={ruumLogoDark} alt="ruum. flow & co." className="bentoGrid__brandLogo" />
          </div>

          <div className="bentoGrid__quoteBlock">
            <div className="bentoGrid__quoteBadge">
              <span className="bentoGrid__quoteCircle">
                <svg viewBox="0 0 100 100" className="bentoGrid__circleText">
                  <defs>
                    <path id="circlePath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
                  </defs>
                  <text>
                    <textPath href="#circlePath" startOffset="0%">
                      RUUM. FLOW &amp; CO. • RUUM. FLOW &amp; CO. •
                    </textPath>
                  </text>
                </svg>
              </span>
            </div>
            <div className="bentoGrid__quoteContent">
              <p className="bentoGrid__quoteLabel">{cms.hero_quote_label}</p>
              <p className="bentoGrid__quoteText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.hero_quote_text) }}></p>
            </div>
          </div>
        </div>
      </section>

      <section className="bottomGrid">
        <div className="bottomGrid__logoBlock">
          <span className="bottomGrid__rLogo">r</span>
          <span className="bottomGrid__rDot"></span>
        </div>

        <div className="bottomGrid__quoteSection">
          <p className="bottomGrid__label">RUUM. FLOW &amp; CO.</p>
          <blockquote className="bottomGrid__quote" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.hero_tagline) }}></blockquote>
          <p className="bottomGrid__body" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.hero_intro_text) }}></p>
        </div>
      </section>

      <section id="o-nas" className="aboutSection">
        <div className="aboutSection__header">
          <h2 className="aboutSection__title">{cms.about_title}</h2>
          <p className="aboutSection__subtitle">{cms.about_subtitle}</p>
        </div>
        <p className="aboutSection__text" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.about_text) }}></p>
        <p className="aboutSection__highlight" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.about_highlight) }}></p>
      </section>

      <section id="filozofia" className="philosophySection">
        <h2 className="philosophySection__title">{cms.philosophy_title}</h2>
        <div className="philosophySection__grid">
          <div className="philosophySection__item philosophySection__item--flow">
            <h3 className="philosophySection__itemTitle">flow</h3>
            <p className="philosophySection__itemText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.philosophy_flow_text) }}></p>
          </div>
          <div className="philosophySection__item philosophySection__item--co">
            <h3 className="philosophySection__itemTitle">&amp; Co.</h3>
            <p className="philosophySection__itemText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.philosophy_co_text) }}></p>
          </div>
        </div>
      </section>

      <section id="uslugi" className="servicesSection">
        <h2 className="servicesSection__title">W CZYM WSPIERAMY PARTNERÓW?</h2>
        <div className="servicesSection__grid">
          <div className="servicesSection__card servicesSection__card--1">
            <span className="servicesSection__number">01</span>
            <h3 className="servicesSection__cardTitle">{cms.service_1_title}</h3>
            <p className="servicesSection__cardSubtitle">{cms.service_1_sub}</p>
            <p className="servicesSection__cardText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.service_1_text) }}></p>
          </div>
          <div className="servicesSection__card servicesSection__card--2">
            <span className="servicesSection__number">02</span>
            <h3 className="servicesSection__cardTitle">{cms.service_2_title}</h3>
            <p className="servicesSection__cardText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.service_2_text) }}></p>
          </div>
          <div className="servicesSection__card servicesSection__card--3">
            <span className="servicesSection__number">03</span>
            <h3 className="servicesSection__cardTitle">{cms.service_3_title}</h3>
            <p className="servicesSection__cardText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.service_3_text) }}></p>
          </div>
          <div className="servicesSection__card servicesSection__card--4">
            <span className="servicesSection__number">04</span>
            <h3 className="servicesSection__cardTitle">{cms.service_4_title}</h3>
            <p className="servicesSection__cardText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.service_4_text) }}></p>
          </div>
        </div>
      </section>

      <section id="dlaczego" className="whySection">
        <h2 className="whySection__title">DLACZEGO RUUM?</h2>
        <blockquote className="whySection__mainQuote" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.why_quote) }}></blockquote>
        <div className="whySection__grid">
          <div className="whySection__item">
            <h3 className="whySection__itemTitle">{cms.why_item_1_title}</h3>
            <p className="whySection__itemText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.why_item_1_text) }}></p>
          </div>
          <div className="whySection__item">
            <h3 className="whySection__itemTitle">{cms.why_item_2_title}</h3>
            <p className="whySection__itemText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.why_item_2_text) }}></p>
          </div>
          <div className="whySection__item">
            <h3 className="whySection__itemTitle">{cms.why_item_3_title}</h3>
            <p className="whySection__itemText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.why_item_3_text) }}></p>
          </div>
        </div>
      </section>

      <section id="zespol" className="teamSection">
        <div className="teamSection__header">
          <h2 className="teamSection__title">My 3 : flow &amp; Co.</h2>
          <p className="teamSection__intro" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_intro) }}></p>
        </div>

        <div className="teamSection__grid">
          <div className="teamSection__member teamSection__member--1">
            <div className="teamSection__imageWrapper">
              <img src={fotoMagda} alt="Magdalena" className="teamSection__image teamSection__image--magda" />
            </div>
            <h3 className="teamSection__name">{cms.team_magda_name}</h3>
            <p className="teamSection__role">{cms.team_magda_role}</p>
            <p className="teamSection__bio" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_magda_bio) }}></p>
            <blockquote className="teamSection__quote" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_magda_quote) }}></blockquote>
          </div>

          <div className="teamSection__member teamSection__member--2">
            <div className="teamSection__imageWrapper">
              <img src={fotoAga} alt="Agnieszka" className="teamSection__image teamSection__image--aga" />
            </div>
            <h3 className="teamSection__name">{cms.team_aga_name}</h3>
            <p className="teamSection__role">{cms.team_aga_role}</p>
            <p className="teamSection__bio" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_aga_bio) }}></p>
            <blockquote className="teamSection__quote" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_aga_quote) }}></blockquote>
          </div>

          <div className="teamSection__member teamSection__member--3">
            <div className="teamSection__imageWrapper">
              <img src={fotoEdyta} alt="Edyta" className="teamSection__image teamSection__image--edyta" />
            </div>
            <h3 className="teamSection__name">{cms.team_edyta_name}</h3>
            <p className="teamSection__role">{cms.team_edyta_role}</p>
            <p className="teamSection__bio" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_edyta_bio) }}></p>
            <blockquote className="teamSection__quote" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_edyta_quote) }}></blockquote>
          </div>
        </div>

        <div className="teamSection__synergy">
          <h3 className="teamSection__synergyTitle">Nasza Synergia</h3>
          <p className="teamSection__synergyText" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.team_synergy_text) }}></p>
        </div>
      </section>

      <section id="kontakt" className="contactSection">
        <h2 className="contactSection__title">POZNAJMY SIĘ</h2>
        <p className="contactSection__text" dangerouslySetInnerHTML={{ __html: formatPolishText(cms.contact_text) }}></p>
        <div className="contactSection__boxes">
          <a href="tel:+48799072890" className="contactSection__box">
            <h3 className="contactSection__boxTitle">Zadzwoń do nas</h3>
            <p className="contactSection__boxValue">+48 799 072 890</p>
          </a>
          <a href="mailto:biuro@ruum.com.pl" className="contactSection__box">
            <h3 className="contactSection__boxTitle">Napisz do nas</h3>
            <p className="contactSection__boxValue">biuro@ruum.com.pl</p>
          </a>
        </div>
      </section>

      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <h3 className="footer__logo">
              <span className="footer__logoRuum">ruum.</span>
              <span className="footer__logoFlow">flow</span>
              <span className="footer__logoCo">&nbsp;&amp;&nbsp;co.</span>
            </h3>
            <p className="footer__tagline">Architektura naturalnej energii.</p>
          </div>
          
          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__columnTitle">Nawigacja</h4>
              <ul className="footer__list">
                <li><button onClick={() => scrollToSection('o-nas')} className="footer__link">O nas</button></li>
                <li>
                  <a href={ofertaPDF} target="_blank" rel="noopener noreferrer" className="footer__link">
                    Oferta
                  </a>
                </li>
                <li><button onClick={() => scrollToSection('filozofia')} className="footer__link">Filozofia</button></li>
                <li><button onClick={() => scrollToSection('uslugi')} className="footer__link">Usługi</button></li>
                <li><button onClick={() => scrollToSection('dlaczego')} className="footer__link">Dlaczego ruum</button></li>
                <li><button onClick={() => scrollToSection('zespol')} className="footer__link">Zespół</button></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4 className="footer__columnTitle">Kontakt</h4>
              <ul className="footer__list">
                <li><a href="mailto:biuro@ruum.com.pl" className="footer__link">biuro@ruum.com.pl</a></li>
                <li><span className="footer__link">+48 799 072 890</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="footer__colorBar">
            <span className="footer__swatch footer__swatch--cream"></span>
            <span className="footer__swatch footer__swatch--yellow"></span>
            <span className="footer__swatch footer__swatch--coral"></span>
            <span className="footer__swatch footer__swatch--sage"></span>
            <span className="footer__swatch footer__swatch--mint"></span>
            <span className="footer__swatch footer__swatch--teal"></span>
          </div>
          <p className="footer__copy">&copy; 2026 ruum. flow &amp; co. Wszelkie prawa zastrzezone.</p>
        </div>
      </footer>
    </main>
  );
}

export default Home;